import BmConfirmationDialog from "@/components/dialogs/BmConfirmationDialog.vue";
import BmInformationDialog from "@/components/dialogs/BmInformationDialog.vue";
import type {
  BmConfirmationDialogOptions,
  BmInformationDialogOptions,
} from "@/components/dialogs/DialogTypes";
import { showModalDialog } from "@/components/platform/common/showModalDialog";
import BmUnauthorisedDialog from "@/components/dialogs/BmUnauthorisedDialog.vue";
import type { UnauthorisedComponentProps } from "@/components/pages/UnauthorisedComponent.vue";

export async function showConfirmationDialog(
  title: string,
  message: string,
  options?: Partial<BmConfirmationDialogOptions>
): Promise<boolean> {
  const result = await showModalDialog<void, typeof BmConfirmationDialog>(
    BmConfirmationDialog,
    {
      props: { title, message, options: options ?? {} },
    }
  );

  return result.wasSuccessful;
}

export async function showInformationDialog(
  title: string,
  message: string,
  options?: Partial<BmInformationDialogOptions>
): Promise<boolean> {
  const result = await showModalDialog<void, typeof BmInformationDialog>(
    BmInformationDialog,
    {
      props: { title, message, options: options ?? {} },
    }
  );

  return result.wasSuccessful;
}

export async function showUnauthorisedDialog(opts: UnauthorisedComponentProps) {
  return await showModalDialog<void, typeof BmUnauthorisedDialog>(
    BmUnauthorisedDialog,
    {
      props: {
        ...opts,
      },
    }
  );
}
